// bajaResolucion.js — P3-9b (remate), generalizado a RATIO en P3-12. ¿Una foto de producto queda
// BAJA DE RESOLUCIÓN una vez encuadrada a la proporción de SU TIPO? El tema sirve la foto hasta
// 1600 px de ANCHO; por debajo se ve blanda en escritorio. El criterio NO mira el ancho bruto sino
// el ancho EFECTIVO tras el encuadre: a 4:5 una foto más ancha pierde los lados (ancho = alto·0,8);
// a 1:1, ancho = alto. Criterio (Miguel, P3-12): min(ancho, alto·ratioW/ratioH) < 1600.
// Informativo: NO bloquea nada. Frontend-only. El ratio por defecto es 4:5 (compat: la prenda).
export const UMBRAL_NITIDEZ = 1600;

// Ancho efectivo tras encuadrar a la proporción (ancho = alto·ratioW/ratioH si la foto es más ancha).
export function anchoEncuadrado(ancho, alto, ratioW = 4, ratioH = 5) {
  return Math.round(Math.min(Number(ancho) || 0, ((Number(alto) || 0) * ratioW) / ratioH));
}

export function esBajaResolucion(ancho, alto, ratioW = 4, ratioH = 5) {
  return anchoEncuadrado(ancho, alto, ratioW, ratioH) < UMBRAL_NITIDEZ;
}
